import "./RibbonElementControlledSelectCheckbox.css";

import { useState } from "react";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Tooltip } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Popover from "@mui/material/Popover";

const RibbonElementControlledSelectCheckbox = ({ elementSettings }) => {
	const { name, _children, icon, isDisabled, nameVisible, onChange } = elementSettings;
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (event) => setAnchorEl(event.currentTarget);
	const handleClose = () => setAnchorEl(null);
	const handleChange = (val) => onChange(val);

	const open = Boolean(anchorEl);

	return (
		<div className="ribbon-element-select-checkbox">
			<Tooltip title={nameVisible && name}>
				<span>
					<button className="ribbon-element-common" disabled={isDisabled} onClick={handleClick} onMouseDown={(e) => e.preventDefault()}>
						{icon}
						{!nameVisible && name}
						<ArrowDropDownIcon />
					</button>
				</span>
			</Tooltip>

			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				onClick={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
			>
				<div className="ribbon-select-options">
					<FormGroup>
						{_children.map((ch, index) => {
							if (ch.isVisible === false) {
								return <span key={index}></span>;
							}
							return (
								<div className="ribbon-element-checkbox" key={index}>
									<FormControlLabel
										control={
											<Checkbox
												checked={ch.value}
												onChange={(e) => handleChange({ keyName: ch.keyName, newValue: e.target.checked })}
												size="small"
											/>
										}
										label={ch.name}
									/>
								</div>
							);
						})}
					</FormGroup>
				</div>
			</Popover>
		</div>
	);
};

export default RibbonElementControlledSelectCheckbox;
